import React from 'react';
import PropTypes from 'prop-types';
import DotAndBlobBack from '../../../svg/blob-with-corner.svg';
import BlueDotSVG from '../../../svg/class-blue-dots.svg';
import './bannerBottomImage.css';

export default function BannerWithBottomImage({
  className = 'Js class for beginners Zero to Hero',
  teacherName = 'John Doe',
  image = 'https://cdn.icon-icons.com/icons2/2959/PNG/512/rocket_space_icon_185991.png',
  isDiscoverable = false,
  imgStyle = {}
}) {
  return (
    <div className="banner1-container" id="banner-img">
      <img
        src={isDiscoverable ? DotAndBlobBack : BlueDotSVG}
        alt="background"
        className="banner1-background"
        style={imgStyle}
      />
      <div className="banner1-content-wrapper">
        <div className="banner1-logo">
          <img src="/static/logo.svg" alt="logo" />
        </div>
        <div className="banner1-info">
          <h1 className="banner1-classTitle">{className}</h1>
          <div className="banner1-teacherName">By {teacherName}</div>
        </div>
        <div className="banner1-right-image">
          <img src={image} alt="user" />
        </div>
      </div>
    </div>
  );
}

BannerWithBottomImage.propTypes = {
  className: PropTypes.string,
  teacherName: PropTypes.string,
  image: PropTypes.string,
  isDiscoverable: PropTypes.bool,
  imgStyle: PropTypes.object
};
